module.exports = __webpack_public_path__ + "img/1527635136.cc6fe161.jpg";